import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { createTranslateLoader } from '../../../../shared/modules/confirmacion-observacion/confirmacion-observacion.module';
import { HttpClient } from '@angular/common/http';
import { MatCustomTableModule } from '../../../../shared/modules/mat-custom-table/mat-custom-table.module';
import { MaterialModule } from '../../../../shared/librerias/material/material.module';
import { ConfiguracionSistemaGeneralAppComponent } from './configuracionSistemaGeneralApp.component';
import { ComboEstadoModule } from '../../../../shared/modules/comboEstado/combo-estado.module';
import { MenuFormularioModule } from 'src/app/shared/modules';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    NgxDatatableModule,
    MatCustomTableModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    }),
    FormsModule,
    ReactiveFormsModule,
    ComboEstadoModule,
    MenuFormularioModule

  ],
  declarations: [ConfiguracionSistemaGeneralAppComponent],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ],
  exports: [TranslateModule],
  // entryComponents: [ConfiguracionSistemaGeneralAppComponent],
})
export class ConfiguracionSistemaGeneralAppModule { }
